import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';
import { handleApiError } from './axiosConfig';
import { Organizer, Camp } from '../utils/types';

interface GetOrganizerResponse {
  id: number;
  name: string;
  email: string | null;
  street_address: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
  website: string | null;
  phone: string | null;
  description: string | null;
  short_description: string | null;
  google_rating: number | null;
  google_rating_count: number | null;
  google_maps_place_id: string | null;
  camps: Camp[];
}

export const useGetOrganizer = (organizerId: string | undefined) => {
  return useQuery({
    queryKey: ['organizer', organizerId],
    queryFn: async (): Promise<GetOrganizerResponse> => {
      if (!organizerId) {
        throw new Error('Organizer ID is required');
      }
      
      try {
        const response = await apiClient.get<GetOrganizerResponse>(`/api/organizers/${organizerId}`);
        return response;
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to fetch organizer:', errorMessage);
        throw new Error(errorMessage);
      }
    }
  });
};
